// extracted by mini-css-extract-plugin
export var active = "_uc-1";
export var circle = "_uc-0";
export var completed = "_uc-2";
export var connector = "_uc-4";
export var connectorCompleted = "_uc-7";
export var connectorSpacer = "_uc-5";
export var iconStrokeOverride = "_uc-8";
export var labelContainer = "_uc-6";
export var pending = "_uc-3";